import { useSyncExternalStore } from 'react';

const QUERY = '(pointer: coarse)';

const getMediaQueryList = () =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
        ? window.matchMedia(QUERY)
        : null;

const subscribe = (callback: () => void) => {
    const mql = getMediaQueryList();
    if (!mql?.addEventListener) {
        return () => {};
    }
    mql.addEventListener('change', callback);
    return () => mql.removeEventListener('change', callback);
};

const getSnapshot = () => getMediaQueryList()?.matches === true;

// `pointer: coarse` rather than `any-pointer: coarse`, so a mouse plugged into a touch laptop
// still counts as fine. Window width would misread a tablet in portrait as a laptop.
export const useHasCoarsePointer = () =>
    useSyncExternalStore(subscribe, getSnapshot, () => false);
